<template>
  <div class="parameter-options-list">
    <div class="parameter-options-list__header">
      <span class="parameter-options-list__title">Opciones</span>
      <feather-icon
        v-if="!readonly"
        size="18"
        icon="PlusCircleIcon"
        color="green"
        v-tooltip="'Agregar opción'"
        @click="addOption"
      />
    </div>
    <table class="parameter-options-list__table">
      <thead>
        <tr>
          <th class="parameter-options-list__th">Valor</th>
          <th class="parameter-options-list__th">Descripción</th>
          <th
            v-if="!readonly"
            class="parameter-options-list__th parameter-options-list__th--action"
          ></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(option, index) in localOptions"
          :key="'option-' + index"
          class="parameter-options-list__row"
        >
          <td class="parameter-options-list__cell">
            <input
              v-if="!readonly"
              v-model="option.value"
              class="form-control form-control-sm"
              placeholder="Valor"
              @input="emitUpdate"
            >
            <span
              v-else
              class="parameter-options-list__text"
            >{{ option.value }}</span>
          </td>
          <td class="parameter-options-list__cell">
            <input
              v-if="!readonly"
              v-model="option.name"
              class="form-control form-control-sm"
              placeholder="Descripción"
              @input="emitUpdate"
            >
            <span
              v-else
              class="parameter-options-list__text"
            >{{ option.name }}</span>
          </td>
          <td
            v-if="!readonly"
            class="parameter-options-list__cell parameter-options-list__cell--action"
          >
            <feather-icon
              v-tooltip="'Eliminar opción'"
              size="16"
              icon="XCircleIcon"
              color="red"
              @click="deleteOption(index)"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ParameterOptionsList',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localOptions: this.options.map(opt => ({ ...opt }))
    };
  },
  watch: {
    options(newOptions) {
      this.localOptions = newOptions.map(opt => ({ ...opt }));
    }
  },
  methods: {
    addOption() {
      this.localOptions.push({ value: '', name: '' });
      this.emitUpdate();
    },
    deleteOption(index) {
      this.localOptions.splice(index, 1);
      this.emitUpdate();
    },
    emitUpdate() {
      this.$emit('update:options', this.localOptions.map(opt => ({ ...opt })));
    }
  }
};
</script>

<style scoped>
.parameter-options-list {
  margin-top: 8px;
}

.parameter-options-list__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  padding-bottom: 4px;
  border-bottom: 1px solid #e9ecef;
}

.parameter-options-list__title {
  font-weight: 600;
  font-size: 0.8rem;
  color: #6c757d;
}

.parameter-options-list__table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.parameter-options-list__th {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6c757d;
  padding: 4px 6px;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
}

.parameter-options-list__th--action {
  width: 30px;
}

.parameter-options-list__row:nth-child(even) {
  background-color: #f8f9fa;
}

.parameter-options-list__cell {
  padding: 4px 6px;
  vertical-align: middle;
}

.parameter-options-list__cell--action {
  width: 30px;
  text-align: center;
  cursor: pointer;
}

.parameter-options-list__text {
  display: block;
  word-break: break-all;
  font-size: 0.8rem;
  font-family: monospace;
}
</style>
